import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {UserRoleEnum} from '@/enums/userRolesEnum'
import {FacilityCredential, IssuableController} from "@/components/provider/cards/issuables/IssuableModels";
import {getRestParamErrorMessage} from "@/utils/serverErrorMessageUtil";
import FacilityCredentialDetail from "@/components/provider/cards/facilityCredentials/FacilityCredentialDetail";
import IssuableCard from "@/components/provider/cards/issuables/IssuableCard";

export default Vue.component('facility-credentials-card', {
  name: 'FacilityCredentialsCard',
  components: {
    IssuableCard,
    FacilityCredentialDetail,
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    }
  },
  methods: {
    issuableController() : IssuableController<FacilityCredential> {
      return {
        entityName: "Facility Credential",
        entityType: 1,
        documentUploadPath: "provider/credential/",
        primaryIdField: "credentialId",
        createNewModel(providerId: string): any {
          return {
            providerId: providerId,
            facilityId: null,
            facilityName: "",
            facilityNickName: "",
            issuedDate: null,
            expirationDate: null,
            expirationNoticeDate: null,
            expirationNoticeSetting: 0,
            isWelcomed: true,
            note: "",
            isNew: true,
            isEditing: true,
          }
        },
        getAllForProvider(providerId: string): Promise<any> {
          return HTTP.get('/api/providers/' + providerId + '/credentials')
        },
        createData(providerId: string, issuable: FacilityCredential): Promise<any> {
          return HTTP.post('/api/providers/' + providerId + '/credentials', issuable);
        },
        deleteData(providerId: string, id: number): Promise<any> {
          return HTTP.delete('/api/providers/' + providerId + '/credentials/' + id);
        },
        deleteDocument(id: number): Promise<any> {
          return HTTP.delete('/api/facilityCredentialDocument/' + id );
        },
        errorsExistOnDynamicFields(issuable: FacilityCredential): boolean {
          return issuable.facilityIdErrorMessage.length > 0 || issuable.specialtyIdErrorMessage.length > 0;
        },
        setErrorsOnDynamicFields(issuable: FacilityCredential, error: any): void {
          issuable.facilityIdErrorMessage = getRestParamErrorMessage(error, 'facilityId');
          issuable.specialtyIdErrorMessage = getRestParamErrorMessage(error, 'specialtyId');
        },
        updateData(providerId: string, issuable: FacilityCredential): Promise<any> {
          return HTTP.put('/api/providers/' + providerId + '/credentials', issuable)
        }
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/facilityCredentials/FacilityCredentialsCard.ts